import constate from 'constate';
import useToastHook from './useToast';

export const [ToastProvider, useToast] = constate(useToastHook);
